import React from "react";
import Slogan from "../mapcomponents/Slogan";
import Map from "../mapcomponents/Map";

const MapPage = () => {
  return (
    <div className="map-page">
      <Slogan
        main={"Live Where You Feel Secure"}
        sub={"Click on the suburbs to discover rental options."}
      />
      <main className="main-content">
        <Map />
      </main>
    </div>
  );
};

export default MapPage;
